import IChannelMessages from "interfaces/IChannelMessages";
import ILogbook from "interfaces/ILogbook";

export interface ILogBookStoreState {
  selectedChannelMessages?: IChannelMessages;
  logbook?: ILogbook;
  hasLogbook?: boolean;
}

export const initialLogBookStoreState: ILogBookStoreState = {};
